import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { StringBoolean, StringBooleanEnum } from '../../../../../../data-models/common/common.interface';
import { VantageShellService } from '../../../../../../services/vantage-shell/vantage-shell.service';
import {
	CapabilityTemp,
	FnLockStatus,
	PrimaryKeySetting,
	TopRowFunctionsIdeapad,
} from './top-row-functions-ideapad.interface';

const CACHE_SIZE = 1;

@Injectable({
	providedIn: 'root',
})
export class TopRowFunctionsIdeapadService {
	topRowFunctionsIdeaPadFeature: TopRowFunctionsIdeapad;
	private capability$: Observable<CapabilityTemp[]>;
	private primaryKey$: Observable<PrimaryKeySetting>;
	private fnLockStatus$: Observable<FnLockStatus>;

	constructor(private shellService: VantageShellService) {
		this.topRowFunctionsIdeaPadFeature = this.shellService.getTopRowFunctionsIdeapad();
	}

	get capability() {
		if (!this.capability$) {
			this.capability$ = this.requestCapability().pipe(shareReplay(CACHE_SIZE));
		}
		return this.capability$;
	}

	requestCapability(): Observable<CapabilityTemp[]> {
		return from(this.topRowFunctionsIdeaPadFeature.getCapability()).pipe(
			map((res) => res.capabilityList.Items)
		);
	}

	getCapability(): Promise<boolean> {
		return this.topRowFunctionsIdeaPadFeature.getCapability().then((result) => {
			let hasCapability = false;
			result.capabilityList.Items.forEach((capability) => {
				const { key, value } = capability;
				if (key === 'FnLock' && value === StringBooleanEnum.TRUTHY) {
					hasCapability = true;
				}
			});
			return hasCapability;
		});
	}

	get primaryKey(): Observable<PrimaryKeySetting> {

		this.primaryKey$ = this.requestPrimaryKey().pipe(shareReplay(CACHE_SIZE));

		return this.primaryKey$;
	}

	requestPrimaryKey(): Observable<PrimaryKeySetting> {
		return from(this.topRowFunctionsIdeaPadFeature.getPrimaryKey()).pipe(
			map((res) => res.settingList.setting.find((item) => item.key === 'PrimeKey'))
		);
	}

	get fnLockStatus(): Observable<FnLockStatus> {

		this.fnLockStatus$ = this.requestFnLockStatus().pipe(shareReplay(CACHE_SIZE));

		return this.fnLockStatus$;
	}

	requestFnLockStatus(): Observable<FnLockStatus> {
		return from(this.topRowFunctionsIdeaPadFeature.getFnLockStatus()).pipe(
			map((res) => res.settingList.setting.find((item) => item.key === 'FnLock'))
		);
	}

	setFnLockStatus(fnLock: StringBoolean) {
		// Every time set new fnLock status clear the cache.
		this.fnLockStatus$ = null;
		return from(this.topRowFunctionsIdeaPadFeature.setFnLockStatus(fnLock));
	}
}
